export default "__VITE_ASSET__838eb3ed__"